



















import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {PutShippingsAssignInvoiceRequest} from 'supporter';


@Component({
  components: {CompSelectBox}
})
export default class DeliveryCell extends Vue {
  @Prop({default: (): any => []})
  public deliveryCompanyTypeArr: any;
  @Prop({required: true})
  item!: any;
  @Prop({required: true})
  shippingRespItem!: any;

  @Ref('input')
  readonly input: HTMLInputElement;

  private modifyMode = false;
  private deliveryCompanyType = '';
  private invoiceNo = '';


  private onTextChanged() {
    this.input.value = this.input.value.replace(/[^0-9a-zA-Z]/g, '');
    this.invoiceNo = this.input.value;
  }

  private toggleModifyMode(){
    this.modifyMode = !this.modifyMode;
  }

  private get showModifyButton(){
    return this.hasInvoiceNo && this.isEditableOrder(this.item.orderStatusType)
  }

  private get showDash(){
    return !this.hasInvoiceNo && !this.isEditableOrder(this.item.orderStatusType)
  }

  created(){
    this.init()
  }

  private init(){
    this.modifyMode = !this.hasInvoiceNo && this.isEditableOrder(this.item.orderStatusType)
    if(this.shippingRespItem?.deliveryCompanyType === undefined || this.shippingRespItem.deliveryCompanyType === null){
      this.deliveryCompanyType = undefined
      return
    }

    this.deliveryCompanyType = this.shippingRespItem?.deliveryCompanyType
    this.invoiceNo = this.shippingRespItem.invoiceNo
  }

  private get hasInvoiceNo(): boolean {
    return Boolean(this.shippingRespItem.invoiceNo)
  }

  private isEditableOrder(status: string): boolean {
    const canEditInvoiceStatus = ['DEPOSIT_WAIT', 'PAY_DONE', 'PRODUCT_PREPARE', 'DELIVERY_PREPARE', 'DELIVERY_ING', 'DELIVERY_DONE'];

    return canEditInvoiceStatus.includes(status)
  }

  // from '@/components/order/mixins/OrderProductInfo.ts' getDeliveryCompaniesLabel
  public getDeliveryCompaniesLabel(type: any): any {
    let conpanyType: any = '';
    this.deliveryCompanyTypeArr.forEach((item: any): any => {
      if (item.deliveryCompanyType === type) {
        conpanyType = item.label;
      }
    });
    return conpanyType;
  }

  // from '@/components/order/mixins/OrderProductInfo.ts' onClickInvoiceInfo
  public onClickInvoiceInfo(url: string): void {
    window.open(url);
  }

  // from '@/components/order/mixins/OrderProductInfo.ts' onClickSaveInvoiceBtn
  private onSaveInvoice(): void {
    if (this.deliveryCompanyType === undefined) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_1'));
      return;
    }
    if (!this.invoiceNo.trim()) {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_2'));
      return;
    }

    const {item, deliveryCompanyType, invoiceNo} = this
    const invoicesRequest: PutShippingsAssignInvoiceRequest = {
      data: {
        shippingNo: item.shippingNo,
        mallNo: item.mallNo,
        deliveryCompanyType,
        invoiceNo,
      }
    };

    this.$api.putShippingsAssignInvoice(invoicesRequest).then(() => {
      alert(this.$t('ORDER_ORDER_DETAIL_ALERT_3'));
      location.reload();
    });
  }
}

